import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Restroom = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Restroom' {...props}>
    <path fill='none' stroke='#000' strokeLinecap='round' strokeWidth='2' d='M6,11 L18,11 M6,3 L18,3 M12,16 C14.7614237,16 17,13.7614237 17,11 C17,11 7,11 7,11 C7,13.7614237 9.23857625,16 12,16 Z M7,3 L17,3 L17,11 L7,11 L7,3 Z M7,6 L9.5,6 M14.5,15.5 L16,21.5 L8,21.5 L9.5,15.5' />
  </StyledIcon>
);
